import $ from 'jquery';

/**
 * @typedef {Partial<import('../../modules/components/toast.js').MpToastOptions & { timeout?: any; timeOut:? any; duration?: any; closeButton?: any; doScroll: boolean; }>} MpCompatibleToastOptions
 */

/**
 * @param { 'string' | HTMLElement | JQuery } element
 * @param { string } content
 * @param { 'toast' | 'inline' } type
 * @param { MpCompatibleToastOptions } options
 */
mpro.addFormError = function(element, content, type = 'inline', options = {}) {

	// Shift arguments if type is not provided
	if (typeof type === 'object') {
		options = type;
		type = 'inline';
	}

	// Toast notification
	if (type === 'toast') {
		mpro.toast({
			...options,
			content,
			format: 'error',
		});
	}
	// Inline form message/error
	else if (type === 'inline') {

		// Save config vars
		const { ui } = mpro.config;
		const $element = (typeof element === 'string') ? $(element) : $(element);
		const baseErrorId = 'custom-error-message';

		// Show errors at the top of the form
		if ($element.is('form')) {
			const topLevelClass = ui?.form_validator_top_level_class || 'alert alert--error alert--dismissible';
			const topLevelSelector = '.' + topLevelClass.split(' ').join('.');
			let $topLevelErrorsContainer = $element.find(topLevelSelector);
			if ($topLevelErrorsContainer.length === 0) {
				$topLevelErrorsContainer = $(`<div class="${topLevelClass}"><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="${mpro.Sanitize.attr(mpro.langvar('button_close'))}"></button>
				<div class="alert__icon"><svg class="icon"><use xlink:href="#icon-error" href="#icon-error"></use></svg></div><div class="alert__message"></div>`);
				$element.prepend($topLevelErrorsContainer);
			}

			const errorId = baseErrorId + '-' + ($topLevelErrorsContainer.find(`[data-error-type^="${baseErrorId}"]`).length + 1);
			const errorMessage = `<div data-error-type="${errorId}">${content}</div>`;
			$topLevelErrorsContainer.find('.alert__message').append(errorMessage);
		}
		// Show errors under the element
		else {

			const useParsley = $element.is('input,select,textarea') && $element.closest('form').is(ui.form_js_validation_selector) ? true : false;
			const rowSelector = ui.form_validator_container_selector || '.form__option-group, .form__group, .form__row';
			const rowInvalidClass = ui.form_row_invalid_class || 'form__row--invalid';
			const errorContainerClass = ui.form_row_invalid_feedback_class || 'form__invalid--feedback';
			const $row = $element.closest(rowSelector);

			// Make sure the row has the correct classes
			$row.addClass(rowInvalidClass);
			let $errorContainer = $row.find('.' + errorContainerClass);

			// Use the Parsley.js API
			if (useParsley) {
				const errorId = baseErrorId + '-' + ($errorContainer.find(`[class*="${baseErrorId}"]`).length + 1);
				$element.parsley().addError(errorId, { message: content });
			}
			// Use the default method
			else {
				// Make sure the error container exists
				if ($errorContainer.length === 0) {
					$errorContainer = $(`<div class="${errorContainerClass}"></div>`);
					$row.append($errorContainer);
				}
				const errorId = baseErrorId + '-' + ($errorContainer.find(`[data-error-type^="${baseErrorId}"]`).length + 1);
				$errorContainer.append(`<div data-error-type="${errorId}">${content}</div>`);
			}
		}

		// Scroll to the first error
		if (options.doScroll) {
			try {
				const topLevelClass = ui?.form_validator_top_level_class || 'alert alert--error alert--dismissible';
				const topLevelSelector = '.' + topLevelClass.split(' ').join('.');
				const rowSelector = ui.form_validator_container_selector || '.form__option-group, .form__group, .form__row';
				const $scrollToElement = $element.is('form') ? $element.find(topLevelSelector) : $element.closest(rowSelector);

				if ($scrollToElement.length > 0) {
					mpro.scrollToElement($scrollToElement, { blink: true });
				}
			}
			catch (error) {
				console.warn('Cannot scroll to element in mpro.addFormError', error);
			}
		}
	}
};

/**
 * @param { 'string' | HTMLElement | JQuery } element
 */
mpro.clearFormErrors = function(element, type = 'inline') {

	const $element = (typeof element === 'string') ? $(element) : $(element);
	const { ui } = mpro.config;

	// Inline form message/error
	if (type === 'inline') {
		if ($element.is('form')) {
			const topLevelClass = ui?.form_validator_top_level_class || 'alert alert--error alert--dismissible';
			const topLevelSelector = '.' + topLevelClass.split(' ').join('.');
			$element.find(topLevelSelector).remove();
		}
		else {

			const useParsley = $element.is('input,select,textarea') && $element.closest('form').is(ui.form_js_validation_selector) ? true : false;

			// Use the Parsley.js API
			if (useParsley) {
				// $element.parsley().removeError(errorId);
				$element.parsley().reset();
			}

			const errorContainerClass = ui.form_row_invalid_feedback_class || 'form__invalid--feedback';
			const rowSelector = ui.form_validator_container_selector || '.form__option-group, .form__group, .form__row';
			const rowInvalidClass = ui.form_row_invalid_class || 'form__row--invalid';
			const $row = $element.closest(rowSelector);
			$row.removeClass(rowInvalidClass);
			$row.find('.' + errorContainerClass).remove();
		}
	}
	// Toast notification
	else if (type === 'toast') {
		mpro.clearToasts();
	}
};

export default mpro;